import React from 'react';
import { lazy } from 'react';
import { redirect, Outlet } from 'react-router-dom';
import Loadable from '../Loadable';
import ErrorPage from '../ErrorPage';
import { g_Auth } from '../../apis/apiAuth';

const Login = Loadable(lazy(() => import('./Login')));
const ChangeLoginOrg = Loadable(lazy(() => import('./ChangeLoginOrg')));
const LoginToSub = Loadable(lazy(() => import('./LoginToSub')));
const Forgot = Loadable(lazy(() => import('./Forgot')));
const Reset = Loadable(lazy(() => import('./Reset')));

async function loginLoader({ params, request }) {
  if (g_Auth.token) {
    console.log('loginLoader', 'Authenticated');
    return redirect('/home');
  }
  console.log('loginLoader', 'Not Authenticated');
  return null;
}

const width = '600px';

const LoginRoutes = {
  id: 'root',
  path: '/',
  loader({ params, request }) {
    console.log('loader for /', params, request);
    return null;
  },
  element: <Outlet />,
  errorElement: <ErrorPage />,
  children: [
    { index: true, element: <Login width={width} /> },
    { path: 'login', loader: loginLoader, element: <Login width={width} /> },
    { path: 'changeloginorg', loader: loginLoader, element: <ChangeLoginOrg width={width} /> },
    { path: 'logintosub', loader: loginLoader, element: <LoginToSub width={width} /> },
    { path: 'forgot', element: <Forgot width={width}/> },
    { path: 'reset?', element: <Reset width={width} /> },
  ]
};

export default LoginRoutes